<template>
	<div class="weighing-factor-progress-bar tw--mt-4">
		<div>
			<div class="tw-flex tw-justify-between tw-mr-8 relative" style="bottom: -12px">
				<span class="text-info text-sm">{{ factor.name }}</span>
				<span class="text-secondary"><slot name="factor-percentage"></slot></span>
			</div>
			<factor-progress-bar
				:length="factorCombinations.length"
				:completed-items-count="factorWeighingCompletedCount"
				complete-position="bottom"
				class="tw-w-full"
			/>
		</div>
	</div>
</template>

<script>
import CheckIconFilled from '@/modules/shared/components/icons/check-icon-filled';
import FactorProgressBar
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/commons/FactorProgressBar';
import {
	factorWeighingCompletedCount,
	factorWeighingIsCompleted,
	getFactorCombinations,
} from '../../../../../utils/valuation-model/factors';

export default {
	name: 'WeighingFactorProgressBar',
	components: { FactorProgressBar, CheckIconFilled },
	props: ['factor', 'completePosition', 'combinations'],
	computed: {
		factorWeighingIsCompleted() {
			return factorWeighingIsCompleted(this.factor, this.combinations);
		},
		factorCombinations() {
			return getFactorCombinations(this.factor, this.combinations);
		},
		factorWeighingCompletedCount() {
			return factorWeighingCompletedCount(this.factor, this.combinations);
		},
	},
};
</script>

<style lang="scss" scoped>
.weighing-factor-progress-bar {
	position: relative;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/commons/WeighingFactorProgressBar.vue